import React, { useCallback, useState, } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import { components, } from 'styles';

export type ChildrenRenderProps = {
    open: boolean,
    handleClickOpen: () => void,
    handleClose: () => void,
    setOpen: (open: boolean) => void,
};

type Props = {
    children: (props: ChildrenRenderProps) => JSX.Element,
    renderContent: (props: ChildrenRenderProps) => JSX.Element,
};

const SummaryOrderTermDialog: React.FC<Props> = ({ children, renderContent, }) => {
    const [ open, setOpen ] = useState(false);
    const dialogTitleClasses = components.makeDialogTitleStyles();

    const handleClickOpen = useCallback(() => {
        setOpen(true);
    }, []);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const renderProps = {
        handleClickOpen,
        handleClose,
        setOpen,
        open,
    };

    return (
        <>
            {children(renderProps)}
            <Dialog fullWidth
                    maxWidth="sm"
                    open={open}
                    onClose={handleClose}>
                <DialogTitle classes={dialogTitleClasses}
                             disableTypography>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {renderContent(renderProps)}
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default SummaryOrderTermDialog;
